import script from "./UIOtpInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIOtpInput.vue?vue&type=script&lang=ts&setup=true"

import "./UIOtpInput.vue?vue&type=style&index=0&id=f51da6d6&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f51da6d6"]])

export default __exports__